<!--
 * @Description: 
 * @version: 
 * @Author: kxl
 * @Date: 2019-12-30 11:12:20
 * @LastEditors: kxl
 -->
<template>
    <div>
        <CommonBox title="Special Recommendation" @close="$emit('close')" @submit="$emit('close')">
         <br>
            <p style="padding-bottom: 10px;"></p>   
        <el-button style="margin-bottom: 15px;" v-for="item in userDataList"
                        @click="recommend(item[0])"
                        :key="item[0].ID"
                        :label="item[0].ID"
                        :value="item[0].ID">
                        {{item[0].CompanyName}}
           </el-button>
    </CommonBox>
        <UpdateBox
      :initForm="updateForm"
      v-if="updateBlock"
      @close="updateBlock = false"
    ></UpdateBox>   
    </div>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
import UpdateBox from "./UpdateBox1.vue";
export default {
    components:{
        CommonBox,
        UpdateBox
    },
    props:{
    },
    data () {
        return {
            updateBlock: false,
            userDataList:[]
        };
    },
    mounted () {
        this.getAccountBindingAll();
    },
    methods:{
        getAccountBindingAll () {
            this.$http.get("getAccountBindingAll",{},(data)=>{
                this.userDataList = data.data;
            });
        },
        recommend (val) {
            this.updateBlock = true;
            this.updateForm = val;
            /*        this.$http.get("getPartnerInfo",{},(data)=>{
                this.userDataList = data.data;
              
            }); */
        },
        submit () {
            this.checkedPartnersID = this.checkedPartnersID.join(";");
            let url = "sendEmailPartner";
            this.$http.put(url,{
                CheckedPartnersID:this.checkedPartnersID  
            },(data)=>{
                this.$baseNotice.message(data.msg);
                this.$emit('close');
            });
        },

        handleCheckAllChange(val) {
            this.checkedPartnersID = val ? this.PartnersID : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.partnerList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.partnerList.length;
        }
    }
};
</script>
